import React from 'react';
import { Mail, Github, Linkedin, GraduationCap } from 'lucide-react';

const Header: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header className="bg-white/90 backdrop-blur-md shadow-sm fixed top-0 left-0 right-0 z-50">
      <nav className="container-max px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <button 
              onClick={scrollToTop}
              className="text-2xl font-bold text-primary-600 hover:text-primary-700 transition-colors duration-200"
            >
              Michael Guevarra&apos;s Portfolio
            </button>
          </div>

          {/* Contact Links */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href="mailto:michael@michaelguevarra.com"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="Email"
            >
              <Mail className="h-5 w-5" />
            </a>
            <a
              href="https://github.com/mike22g"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="GitHub"
            >
              <Github className="h-5 w-5" />
            </a>
            <a
              href="https://www.linkedin.com/in/michael-guevarra"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="LinkedIn"
            >
              <Linkedin className="h-5 w-5" />
            </a>
            <a
              href="https://scholar.google.com/citations?user=DswSo0MAAAAJ&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="Google Scholar"
            >
              <GraduationCap className="h-5 w-5" />
            </a>
          </div>

          {/* Mobile Contact Links */}
          <div className="md:hidden flex items-center space-x-2">
            <a
              href="mailto:michael@michaelguevarra.com"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="Email"
            >
              <Mail className="h-4 w-4" />
            </a>
            <a
              href="https://github.com/mike22g"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="GitHub"
            >
              <Github className="h-4 w-4" />
            </a>
            <a
              href="https://www.linkedin.com/in/michael-guevarra"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="LinkedIn"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="https://scholar.google.com/citations?user=DswSo0MAAAAJ&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2 text-secondary-600 hover:text-primary-600 hover:bg-secondary-50 rounded-md transition-colors duration-200"
              title="Google Scholar"
            >
              <GraduationCap className="h-4 w-4" />
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 